import AssetPhotometryButton from '@/components/asset_photometry_button.js';
import ShareSvg from "@/components/svgs/share_svg.js";
import DownloadSvg from "@/components/svgs/download_svg.js";
import ResourceList from "@/components/resource_list";
import Link from "next/link";
import { downloadLink } from "@/lib/utils.js";
import PhotometryButton from '@/components/photometry_button.js'
import ResourcesModal from '@/components/resources_modal.js'

export default function PhotometricDownloadsSection({product, i, resourceCategory,  config, 
  resource_display, show, setShow, slicedDownloads, allDownloads} ) {
  const downloadContainerId = (category) => {
    let categoryId = category
      .toLowerCase()
      .replace("&", "and")
      .trim()
      .replace(/\s/g, "-");
    return `download-cateogry-${categoryId}`;
  };
  return (
   <div key={i} className='lexcms-product-download-container lexcms-photometry-download-container'
            id={`${downloadContainerId(resourceCategory)}`}
          >
            <div className="lexcms-product-download-container-inner" > <span> 
              <div className='lexcms-photometry-downloads-heading'>
                <h4 className="lexcms-product-download-heading">
                  {resourceCategory}
                </h4>
                <div className='lexcms-photometry-downloads-viewer-button-container'>
                 <PhotometryButton product={product} />
                  <p>View photometry in an interactive viewer </p>
                </div>
              </div>
                {resource_display === "modal" && (
                  <div>
                    {allDownloads?.length > 3 && (
                      <div
                        className="lexcms-product-download-view-all-section"
                        onClick={() => setShow(resourceCategory)}
                      >
                        <div className="lexcms-product-download-view-all">
                          View All
                        </div>
                        <div className="lexcms-product-download-view-all-count">
                          ({allDownloads?.length})
                        </div>
                        <div className="lexcms-product-download-view-all-icon"></div>
                      </div>
                    )}
                  </div>
                )}
              </span>

              <hr className="lexcms-section-divider"></hr>

              <ul className="lexcms-product-download-list">
                {slicedDownloads?.map((d, i) => {
                  return (
                    <li
                      key={i}
                      className={`lexcms-product-download-filename lexcms-with-asset-photometry-viewer-button ` }
                    >
                      <div className='lexcms-photometry-download-file-name'>{d.name} </div>
                      
                      <div className='lexcms-photometry-asset-actions'>
                       {d.photometry_viewer &&
                       <AssetPhotometryButton product={product } fileId={d.photometry_viewer } />
                      }
                      <Link href={downloadLink(d)}>
                        <a target="_blank">Download</a>
                      </Link>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
            {resource_display === "modal"   && (
              <ResourcesModal
                show={show === resourceCategory}
                no_close_on_outside_click={true}
                setShow={setShow}> <h3>
                  <strong>{product.name}</strong>: {resourceCategory}{" "}
                </h3>
                <hr className="lexcms-section-divider"></hr>
                <ul className="lexcms-product-download-list">
                  {allDownloads?.map((d, i) => {
                    return (
                      <li
                        key={i}
                        className="lexcms-product-download-filename"
                      >
                        <Link href={downloadLink(d)}>
                          <a target="_blank">{d.name}</a>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </ResourcesModal>
            )}

          </div>
  )
}
